import { UseMutationOptions } from '@tanstack/react-query';

import { CommonSuccess, GenericFailure } from '@playq/services-shared';
import { Environment } from '@playq/octopus-common';

import { useEitherMutation } from '/api/service-hooks';

import { IBeetleWithTags } from './types';
import { methods } from './serviceHandlerRequest';
import { SupportContentType } from './types/supportContentType';

export const useUpdateTags = (
  type: SupportContentType,
  options?: UseMutationOptions<CommonSuccess, GenericFailure | Error, { ids: IBeetleWithTags[]; env: Environment }>
) => {
  const service = methods(type);
  return useEitherMutation(({ ids, env }) => service.updateTags(ids, env), {
    ...options,
  });
};
